import { createContext } from 'react';
import { IssueType } from '@/proto/issue';

export interface ExceptionListContextProps {
  token: string;
  setToken?: (token: string) => void;
  pageId: string;
  issueType?: IssueType;
}

export const NetExceptionListContext = createContext<ExceptionListContextProps>({
  token: '',
  pageId: '',
});
